module.exports = __webpack_public_path__ + "static/media/400144_01.f03b4ab7.png";